module.exports = __webpack_public_path__ + "resources/img/img_alyac1_m.3bee39fa1757fb7125242594472c4b8b.png";